export type BOOTSTRAP_STARTED = 'BOOTSTRAP_STARTED';
export const BOOTSTRAP_STARTED: BOOTSTRAP_STARTED = 'BOOTSTRAP_STARTED';
export type BOOTSTRAP_FINISHED = 'BOOTSTRAP_FINISHED';
export const BOOTSTRAP_FINISHED: BOOTSTRAP_FINISHED = 'BOOTSTRAP_FINISHED';

export type LOCATION_SETTINGS_FETCHING = 'LOCATION_SETTINGS_FETCHING';
export const LOCATION_SETTINGS_FETCHING: LOCATION_SETTINGS_FETCHING = 'LOCATION_SETTINGS_FETCHING';
export type LOCATION_SETTINGS_FETCH_ERROR = 'LOCATION_SETTINGS_FETCH_ERROR';
export const LOCATION_SETTINGS_FETCH_ERROR: LOCATION_SETTINGS_FETCH_ERROR =
    'LOCATION_SETTINGS_FETCH_ERROR';
export type LOCATION_SETTINGS_FETCHED = 'LOCATION_SETTINGS_FETCHED';
export const LOCATION_SETTINGS_FETCHED: LOCATION_SETTINGS_FETCHED = 'LOCATION_SETTINGS_FETCHED';

export type ROXANNE_DATA_FETCHING = 'ROXANNE_DATA_FETCHING';
export const ROXANNE_DATA_FETCHING: ROXANNE_DATA_FETCHING = 'ROXANNE_DATA_FETCHING';
export type ROXANNE_DATA_FETCHED = 'ROXANNE_DATA_FETCHED';
export const ROXANNE_DATA_FETCHED: ROXANNE_DATA_FETCHED = 'ROXANNE_DATA_FETCHED';
export type ROXANNE_DATA_FETCH_ERROR = 'ROXANNE_DATA_FETCH_ERROR';
export const ROXANNE_DATA_FETCH_ERROR: ROXANNE_DATA_FETCH_ERROR = 'ROXANNE_DATA_FETCH_ERROR';

export type CTA_CLICKED = 'CTA_CLICKED';
export const CTA_CLICKED: CTA_CLICKED = 'CTA_CLICKED';
export type PROACTIVE_ADD = 'PROACTIVE_ADD';
export const PROACTIVE_ADD: PROACTIVE_ADD = 'PROACTIVE_ADD';
export type PROACTIVE_REMOVE = 'PROACTIVE_REMOVE';
export const PROACTIVE_REMOVE: PROACTIVE_REMOVE = 'PROACTIVE_REMOVE';
export type PROACTIVE_CLICKED = 'PROACTIVE_CLICKED';
export const PROACTIVE_CLICKED: PROACTIVE_CLICKED = 'PROACTIVE_CLICKED';
export type PROACTIVE_CLOSED = 'PROACTIVE_CLOSED';
export const PROACTIVE_CLOSED: PROACTIVE_CLOSED = 'PROACTIVE_CLOSED';

export type CONVO_WITH_MESSAGE_START_REQUEST = 'CONVO_WITH_MESSAGE_START_REQUEST';
export const CONVO_WITH_MESSAGE_START_REQUEST: CONVO_WITH_MESSAGE_START_REQUEST =
    'CONVO_WITH_MESSAGE_START_REQUEST';
export type SMS_CTA_CLICKED = 'SMS_CTA_CLICKED';
export const SMS_CTA_CLICKED: SMS_CTA_CLICKED = 'SMS_CTA_CLICKED';
export type BOT_CONVO_STARTING = 'BOT_CONVO_STARTING';
export const BOT_CONVO_STARTING: BOT_CONVO_STARTING = 'BOT_CONVO_STARTING';
export type CONVO_START_ERROR = 'CONVO_START_ERROR';
export const CONVO_START_ERROR: CONVO_START_ERROR = 'CONVO_START_ERROR';
export type BOT_CONVO_STARTED = 'BOT_CONVO_STARTED';
export const BOT_CONVO_STARTED: BOT_CONVO_STARTED = 'BOT_CONVO_STARTED';
export type CONVO_DETAILS_FETCHED = 'CONVO_DETAILS_FETCHED';
export const CONVO_DETAILS_FETCHED: CONVO_DETAILS_FETCHED = 'CONVO_DETAILS_FETCHED';
export type CONVO_RESUMED = 'CONVO_RESUMED';
export const CONVO_RESUMED: CONVO_RESUMED = 'CONVO_RESUMED';

export type LOCAL_SETTINGS_LOADED = 'LOCAL_SETTINGS_LOADED';
export const LOCAL_SETTINGS_LOADED: LOCAL_SETTINGS_LOADED = 'LOCAL_SETTINGS_LOADED';

export type SOCKET_EVENT_NEW_BOT_MESSAGE = 'SOCKET_EVENT_NEW_BOT_MESSAGE';
export const SOCKET_EVENT_NEW_BOT_MESSAGE: SOCKET_EVENT_NEW_BOT_MESSAGE =
    'SOCKET_EVENT_NEW_BOT_MESSAGE';

export type NEW_BOT_MESSAGE = 'NEW_BOT_MESSAGE';
export const NEW_BOT_MESSAGE: NEW_BOT_MESSAGE = 'NEW_BOT_MESSAGE';

export type SOCKET_EVENT_STARTED_REAL_CONVO = 'SOCKET_EVENT_STARTED_REAL_CONVO';
export const SOCKET_EVENT_STARTED_REAL_CONVO: SOCKET_EVENT_STARTED_REAL_CONVO =
    'SOCKET_EVENT_STARTED_REAL_CONVO';
export type REAL_CONVO_STARTED = 'REAL_CONVO_STARTED';
export const REAL_CONVO_STARTED: REAL_CONVO_STARTED = 'REAL_CONVO_STARTED';

export type SEND_MESSAGE = 'SEND_MESSAGE';
export const SEND_MESSAGE: SEND_MESSAGE = 'SEND_MESSAGE';

export type MESSAGE_SENT = 'MESSAGE_SENT';
export const MESSAGE_SENT: MESSAGE_SENT = 'MESSAGE_SENT';

export type MESSAGE_SEND_ERROR = 'MESSAGE_SEND_ERROR';
export const MESSAGE_SEND_ERROR: MESSAGE_SEND_ERROR = 'MESSAGE_SEND_ERROR';

export type TOGGLE_MINIMIZED = 'TOGGLE_MINIMIZED';
export const TOGGLE_MINIMIZED: TOGGLE_MINIMIZED = 'TOGGLE_MINIMIZED';

export type TOGGLE_REQUEST_END_CONVO = 'TOGGLE_REQUEST_END_CONVO';
export const TOGGLE_REQUEST_END_CONVO: TOGGLE_REQUEST_END_CONVO = 'TOGGLE_REQUEST_END_CONVO';

export type END_CONVO = 'END_CONVO';
export const END_CONVO: END_CONVO = 'END_CONVO';

export type END_CONVO_PENDING = 'END_CONVO_PENDING';
export const END_CONVO_PENDING: END_CONVO_PENDING = 'END_CONVO_PENDING';

export type END_CONVO_SUCCESS = 'END_CONVO_SUCCESS';
export const END_CONVO_SUCCESS: END_CONVO_SUCCESS = 'END_CONVO_SUCCESS';

export type SOCKET_EVENT_AGENT_ACCEPTED = 'SOCKET_EVENT_AGENT_ACCEPTED';
export const SOCKET_EVENT_AGENT_ACCEPTED: SOCKET_EVENT_AGENT_ACCEPTED =
    'SOCKET_EVENT_AGENT_ACCEPTED';

export type SOCKET_EVENT_NEW_MESSAGE = 'SOCKET_EVENT_NEW_MESSAGE';
export const SOCKET_EVENT_NEW_MESSAGE: SOCKET_EVENT_NEW_MESSAGE = 'SOCKET_EVENT_NEW_MESSAGE';

export type SET_SURVEY_SCORE = 'SET_SURVEY_SCORE';
export const SET_SURVEY_SCORE: SET_SURVEY_SCORE = 'SET_SURVEY_SCORE';

export type SURVEY_COMPLETED = 'SURVEY_COMPLETED';
export const SURVEY_COMPLETED: SURVEY_COMPLETED = 'SURVEY_COMPLETED';

export type SOCKET_EVENT_CONVERSATION_ENDED = 'SOCKET_EVENT_CONVERSATION_ENDED';
export const SOCKET_EVENT_CONVERSATION_ENDED: SOCKET_EVENT_CONVERSATION_ENDED =
    'SOCKET_EVENT_CONVERSATION_ENDED';

export type SOCKET_EVENT_BOT_CONVERSATION_ENDED = 'SOCKET_EVENT_BOT_CONVERSATION_ENDED';
export const SOCKET_EVENT_BOT_CONVERSATION_ENDED: SOCKET_EVENT_BOT_CONVERSATION_ENDED =
    'SOCKET_EVENT_BOT_CONVERSATION_ENDED';

export type HIDE_BANNER = 'HIDE_BANNER';
export const HIDE_BANNER: HIDE_BANNER = 'HIDE_BANNER';

export type REQUEST_MARK_READ = 'REQUEST_MARK_READ';
export const REQUEST_MARK_READ: REQUEST_MARK_READ = 'REQUEST_MARK_READ';

export type MESSAGES_MARKED_READ = 'MESSAGES_MARKED_READ';
export const MESSAGES_MARKED_READ: MESSAGES_MARKED_READ = 'MESSAGES_MARKED_READ';

export type SOCKET_EVENT_CLIENT_CHAT_STATUS_NOTIFICATION = 'SOCKET_EVENT_CLIENT_CHAT_STATUS_NOTIFICATION';
export const SOCKET_EVENT_CLIENT_CHAT_STATUS_NOTIFICATION: SOCKET_EVENT_CLIENT_CHAT_STATUS_NOTIFICATION =
    'SOCKET_EVENT_CLIENT_CHAT_STATUS_NOTIFICATION';

export type CLIENT_CHAT_STATUS_NOTIFICATION = 'CLIENT_CHAT_STATUS_NOTIFICATION';
export const CLIENT_CHAT_STATUS_NOTIFICATION: CLIENT_CHAT_STATUS_NOTIFICATION =
    'CLIENT_CHAT_STATUS_NOTIFICATION';

export type TYPING_STATUS_CHANGE = 'TYPING_STATUS_CHANGE';
export const TYPING_STATUS_CHANGE: TYPING_STATUS_CHANGE = 'TYPING_STATUS_CHANGE';

export type REMOVE_CONVERSATION = 'REMOVE_CONVERSATION';
export const REMOVE_CONVERSATION: REMOVE_CONVERSATION = 'REMOVE_CONVERSATION';

export type LEAVE_MESSAGE_FORM_SUBMIT = 'LEAVE_MESSAGE_FORM_SUBMIT';
export const LEAVE_MESSAGE_FORM_SUBMIT: LEAVE_MESSAGE_FORM_SUBMIT = 'LEAVE_MESSAGE_FORM_SUBMIT';

export type LEAVE_MESSAGE_FORM_SUBMIT_SUCCESS = 'LEAVE_MESSAGE_FORM_SUBMIT_SUCCESS';
export const LEAVE_MESSAGE_FORM_SUBMIT_SUCCESS: LEAVE_MESSAGE_FORM_SUBMIT_SUCCESS =
    'LEAVE_MESSAGE_FORM_SUBMIT_SUCCESS';

export type LEAVE_MESSAGE_FORM_SUBMIT_ERROR = 'LEAVE_MESSAGE_FORM_SUBMIT_ERROR';
export const LEAVE_MESSAGE_FORM_SUBMIT_ERROR: LEAVE_MESSAGE_FORM_SUBMIT_ERROR =
    'LEAVE_MESSAGE_FORM_SUBMIT_ERROR';

export type SOCKET_EVENT_CLIENT_VIDEO_REQUEST = 'SOCKET_EVENT_CLIENT_VIDEO_REQUEST';
export const SOCKET_EVENT_CLIENT_VIDEO_REQUEST: SOCKET_EVENT_CLIENT_VIDEO_REQUEST =
    'SOCKET_EVENT_CLIENT_VIDEO_REQUEST';

export type ACCEPT_VIDEO_REQUEST = 'ACCEPT_VIDEO_REQUEST';
export const ACCEPT_VIDEO_REQUEST: ACCEPT_VIDEO_REQUEST = 'ACCEPT_VIDEO_REQUEST';

export type START_VIDEO = 'START_VIDEO';
export const START_VIDEO: START_VIDEO = 'START_VIDEO';

export type LOCAL_VIDEO_ACTIVE = 'LOCAL_VIDEO_ACTIVE';
export const LOCAL_VIDEO_ACTIVE: LOCAL_VIDEO_ACTIVE = 'LOCAL_VIDEO_ACTIVE';

export type REMOTE_VIDEO_ACTIVE = 'REMOTE_VIDEO_ACTIVE';
export const REMOTE_VIDEO_ACTIVE: REMOTE_VIDEO_ACTIVE = 'REMOTE_VIDEO_ACTIVE';

export type REMOTE_VIDEO_STREAMING = 'REMOTE_VIDEO_STREAMING';
export const REMOTE_VIDEO_STREAMING: REMOTE_VIDEO_STREAMING = 'REMOTE_VIDEO_STREAMING';

export type REMOTE_VIDEO_CLOSED = 'REMOTE_VIDEO_CLOSED';
export const REMOTE_VIDEO_CLOSED: REMOTE_VIDEO_CLOSED = 'REMOTE_VIDEO_CLOSED';

export type VIDEO_CONNECTION_ERROR = 'VIDEO_CONNECTION_ERROR';
export const VIDEO_CONNECTION_ERROR: VIDEO_CONNECTION_ERROR = 'VIDEO_CONNECTION_ERROR';

export type CLOSE_VIDEO_PANEL = 'CLOSE_VIDEO_PANEL';
export const CLOSE_VIDEO_PANEL: CLOSE_VIDEO_PANEL = 'CLOSE_VIDEO_PANEL';

export type END_VIDEO = 'END_VIDEO';
export const END_VIDEO: END_VIDEO = 'END_VIDEO';

export type TOGGLE_VIDEO_STREAM = 'TOGGLE_VIDEO_STREAM';
export const TOGGLE_VIDEO_STREAM: TOGGLE_VIDEO_STREAM = 'TOGGLE_VIDEO_STREAM';

export type TOGGLE_AUDIO_STREAM = 'TOGGLE_AUDIO_STREAM';
export const TOGGLE_AUDIO_STREAM: TOGGLE_AUDIO_STREAM = 'TOGGLE_AUDIO_STREAM';

export type BROWSER_CAPABILITIES_FETCHED = 'BROWSER_CAPABILITIES_FETCHED';
export const BROWSER_CAPABILITIES_FETCHED: BROWSER_CAPABILITIES_FETCHED =
    'BROWSER_CAPABILITIES_FETCHED';

export type START_LOCKED_PRICING_BOT = 'START_LOCKED_PRICING_BOT';
export const START_LOCKED_PRICING_BOT: START_LOCKED_PRICING_BOT = 'START_LOCKED_PRICING_BOT';

export type SOCKET_EVENT_SEND_EXTERNAL_EVENT = 'SOCKET_EVENT_SEND_EXTERNAL_EVENT';
export const SOCKET_EVENT_SEND_EXTERNAL_EVENT: SOCKET_EVENT_SEND_EXTERNAL_EVENT =
    'SOCKET_EVENT_SEND_EXTERNAL_EVENT';

export type SOCKET_EVENT_REDIRECT_TO_URL = 'SOCKET_EVENT_REDIRECT_TO_URL';
export const SOCKET_EVENT_REDIRECT_TO_URL: SOCKET_EVENT_REDIRECT_TO_URL =
    'SOCKET_EVENT_REDIRECT_TO_URL';

export type SOCKET_EVENT_CONTACT_INFO_GATHERED = 'SOCKET_EVENT_CONTACT_INFO_GATHERED';
export const SOCKET_EVENT_CONTACT_INFO_GATHERED: SOCKET_EVENT_CONTACT_INFO_GATHERED =
    'SOCKET_EVENT_CONTACT_INFO_GATHERED';

export type CONTACT_INFO_INJECTED = 'CONTACT_INFO_INJECTED';
export const CONTACT_INFO_INJECTED: CONTACT_INFO_INJECTED = 'CONTACT_INFO_INJECTED';

export type BANNER_INJECTED = 'BANNER_INJECTED';
export const BANNER_INJECTED: BANNER_INJECTED = 'BANNER_INJECTED';

export type LINK_INJECTED = 'LINK_INJECTED';
export const LINK_INJECTED: LINK_INJECTED = 'LINK_INJECTED';

export type HIDE_CTA = 'HIDE_CTA';
export const HIDE_CTA: HIDE_CTA = 'HIDE_CTA';

export type CUSTOM_METADATA_INJECTED = 'CUSTOM_METADATA_INJECTED';
export const CUSTOM_METADATA_INJECTED: CUSTOM_METADATA_INJECTED = 'CUSTOM_METADATA_INJECTED';

export type SET_CTA_TEXT = 'SET_CTA_TEXT';
export const SET_CTA_TEXT: SET_CTA_TEXT = 'SET_CTA_TEXT';

export type SOCKET_EVENT_SENT_TO_CRM = 'SOCKET_EVENT_SENT_TO_CRM';
export const SOCKET_EVENT_SENT_TO_CRM: SOCKET_EVENT_SENT_TO_CRM = 'SOCKET_EVENT_SENT_TO_CRM';



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/typedefs/actionTypes.ts